module.exports = __webpack_public_path__ + "img/doctor.51123251.png";